module.exports = __webpack_public_path__ + "static/media/darklogo.1a395d9a.png";